import { jsx as t, jsxs as s, Fragment as $ } from "react/jsx-runtime";
import E, { useMemo as d } from "react";
import a from "./style.module.less.js";
import U from "./social-fb.svg.js";
import D from "./social-instagram.svg.js";
import M from "./social-tik-tok.svg.js";
import x from "./social-youtube.svg.js";
import B from "./social-ln.svg.js";
import Y from "./logo-white.webp.js";
import { CountryLanguageSelector as H } from "../country-language-selector/index.js";
import { DEFAULT_LANGUAGE_CODE as K, canLanguageUseAtticus as Q, areasOfLawData as _, withDirectoryCountries as L, directoryBaseData as C } from "../../../constants.js";
import { convertToKebabCase as A } from "../../../utils/case-conversion.js";
import { getRoute as T, RouteType as q } from "../../../utils/get-route.js";
import { getChatUrl as v, getAccountUrls as W } from "../../../utils/webapp-chat-url.js";
import { trackNewChatClick as R } from "../../../utils/track.js";
import { CHAT_REF as S } from "../../../utils/chat-ref.js";
import P from "../menu/message-animated.svg.js";
import F from "../menu/spark-animated-midnight.svg.js";
import { useFeatureFlags as j } from "../../../context/config-context.js";
const G = [
  {
    name: "Facebook",
    link: "https://www.facebook.com/asklawconnect",
    Icon: U
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/asklawconnect/",
    Icon: D
  },
  {
    name: "TikTok",
    link: "https://www.tiktok.com/@asklawconnect",
    Icon: M
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/company/lawconnect/",
    Icon: B
  },
  {
    name: "Youtube",
    link: "https://www.youtube.com/@asklawconnect",
    Icon: x
  }
], J = () => /* @__PURE__ */ t("div", { className: a.socialContainer, children: G.map((m) => /* @__PURE__ */ t(
  "a",
  {
    href: m.link,
    target: "_blank",
    rel: "noreferrer",
    "aria-label": m.name,
    className: a.socialIconContainer,
    children: /* @__PURE__ */ t(m.Icon, { width: 32, height: 32, className: a.socialIcon })
  },
  m.name
)) }), fe = (m) => {
  const {
    className: e = "",
    onLanguageChange: g,
    isAuthenticated: r,
    openAuthModal: h,
    language: n = K,
    getTranslation: c,
    isLawyerSupported: k,
    legalHubSupported: w,
    onRequestLawyer: I,
    newChatUrl: f
  } = m, y = d(() => n === "en-au", [n]), N = d(() => Q(n) ? n : void 0, [n]), p = d(
    () => c("auth.copyright-terms-privacy").replace(/TERMS_LINK/g, n ? `/${n}/terms` : "/terms").replace(
      /PRIVACY_LINK/g,
      n ? `/${n}/privacy` : "/privacy"
    ),
    [c, n]
  ), i = d(() => n ? [..._[n]].sort(
    (l, b) => l.title.localeCompare(b.title)
  ) : null, [n]), o = /* @__PURE__ */ t(
    H,
    {
      onLanguageChange: g,
      language: n ?? ""
    }
  ), u = () => /* @__PURE__ */ t(
    "a",
    {
      href: W({ origin: f, language: n }).myCasesUrl,
      className: `${a.menuItem}`,
      onClick: (l) => {
        r || (l.preventDefault(), h == null || h());
      },
      children: c("pages.account")
    }
  );
  return /* @__PURE__ */ t("footer", { className: `${a.footer} ${e}`, children: /* @__PURE__ */ s("div", { className: a.widthWrapper, children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: `${a.logoContainer} ${i != null && i.length ? a.large : ""}`,
        children: [
          /* @__PURE__ */ t("a", { href: n ? `/${n}` : "/", className: a.logo, children: /* @__PURE__ */ t(
            "img",
            {
              src: Y,
              width: 202,
              height: 28,
              alt: "LawConnect Logo",
              loading: "lazy",
              className: a.logoImage
            }
          ) }),
          /* @__PURE__ */ t("div", { className: a.headerLanguageSelector, children: o })
        ]
      }
    ),
    i != null && i.length ? /* @__PURE__ */ t("div", { className: `${a.gridContainer} ${a.large}`, children: /* @__PURE__ */ t(
      O,
      {
        language: n,
        accountComponent: /* @__PURE__ */ t(u, {}),
        isLawyerSupported: k,
        onRequestLawyer: N ? I : void 0,
        isLegalMarketplaceEnabled: y,
        legalHubSupported: w,
        newChatUrl: f
      }
    ) }) : /* @__PURE__ */ t("div", { className: a.gridContainer, children: /* @__PURE__ */ t(
      z,
      {
        language: n,
        accountComponent: /* @__PURE__ */ t(u, {}),
        getTranslation: c,
        newChatUrl: f
      }
    ) }),
    /* @__PURE__ */ s("div", { className: a.bottomBarContainer, children: [
      /* @__PURE__ */ s("div", { className: a.bottomSocialContainer, children: [
        /* @__PURE__ */ t(J, {}),
        /* @__PURE__ */ t("div", { className: a.languageSelectorContainer, children: o })
      ] }),
      /* @__PURE__ */ s("div", { className: a.copyright, children: [
        /* @__PURE__ */ t("div", { children: c("auth.copyright").replace(
          "<YEAR>",
          (/* @__PURE__ */ new Date()).getFullYear().toString()
        ) }),
        /* @__PURE__ */ s("div", { className: a.copyrightBottom, children: [
          /* @__PURE__ */ s("div", { children: [
            c("auth.copyright-description"),
            " "
          ] }),
          i != null && i.length ? /* @__PURE__ */ t("div", { dangerouslySetInnerHTML: { __html: p } }) : null,
          n === "en-au" && /* @__PURE__ */ s($, { children: [
            /* @__PURE__ */ t("br", {}),
            /* @__PURE__ */ s("div", { className: a.sitemapLink, children: [
              " ",
              /* @__PURE__ */ t("a", { href: n ? `/${n}/sitemap` : "/sitemap", children: "Sitemap" }),
              "."
            ] })
          ] })
        ] })
      ] })
    ] })
  ] }) });
}, O = (m) => {
  const {
    language: e,
    accountComponent: g,
    isLawyerSupported: r,
    isLegalMarketplaceEnabled: h,
    onRequestLawyer: n,
    legalHubSupported: c,
    newChatUrl: k
  } = m, { diyWill: w } = j(), I = d(() => {
    const o = [..._[e]].sort(
      (u, l) => u.title.localeCompare(l.title)
    );
    return L.includes(e) ? [
      ...o,
      {
        title: C.footerTitle ?? "",
        description: C.description,
        image: C.image,
        link: "topics"
      }
    ] : o;
  }, [e]), f = d(() => L.includes(e), [e]), y = r ? 5 : 4, N = d(() => {
    const o = y * 2, u = I.slice(0, o);
    return [u.slice(0, y), u.slice(y)];
  }, [I, y]), p = c ? "legal-hub" : "topics", i = d(() => [
    {
      header: "Browse",
      items: [
        {
          key: "request",
          label: "Request a lawyer",
          href: n ? void 0 : v({
            origin: k,
            language: e,
            path: T(q.LAWYER_REQUEST_CHAT),
            ref: S.footerRequestLawyer
          }),
          icon: /* @__PURE__ */ t(P, { className: a.menuIcon }),
          className: `${a.menuItem} ${a.requestLawyer}`,
          show: !!r,
          onClick: n
        },
        {
          key: "ask",
          label: "Ask a question",
          href: v({
            origin: k,
            language: e,
            ref: S.footerAsk
          }),
          icon: /* @__PURE__ */ t(F, { className: a.menuIcon }),
          className: `${a.menuItem} ${a.askQuestion}`,
          onClick: () => R("footer")
        },
        {
          key: "library",
          label: c ? "Legal hub" : "Legal topics",
          href: `/${e}/${c ? "legal-hub" : "topics"}`,
          className: a.menuItem
        },
        {
          key: "about",
          label: "About",
          href: r ? e ? `/${e}/about/company` : "/about/company" : e ? `/${e}/about` : "/about",
          className: a.menuItem
        },
        {
          key: "for-lawyers",
          label: "For lawyers",
          href: e ? `/${e}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: a.menuItem
        },
        {
          key: "account",
          node: g,
          show: !r
        }
      ]
    },
    {
      header: "",
      items: [
        {
          key: "make-will",
          label: "Make a will",
          href: T(q.WILL_INFO),
          className: a.menuItem,
          show: e === "en-us" && w === !0
        },
        {
          key: "find-a-lawyer",
          label: "Browse lawyers",
          href: e ? `/${e}/find` : "/find",
          className: a.menuItem,
          show: !!r && h
        },
        {
          key: "insights",
          label: "Insights",
          href: e ? `/${e}/insights` : "/insights",
          className: a.menuItem
        },
        {
          key: "faqs",
          label: "FAQs",
          href: e ? `/${e}/faqs` : "/faqs",
          className: a.menuItem
        },
        {
          key: "directory",
          label: "Case study directory",
          href: e ? `/${e}/directory` : "/directory",
          className: a.menuItem,
          show: f && !!r && !h
        },
        {
          key: "ai-technology",
          label: "Our AI technology",
          href: e ? `/${e}/about/ai-technology` : "/about/ai-technology",
          className: a.menuItem,
          show: !r && !(e === "en-us" && w === !0)
        },
        {
          key: "company",
          label: "Company",
          href: e ? `/${e}/about/company` : "/about/company",
          className: a.menuItem,
          show: !r
        },
        {
          key: "contact",
          label: "Contact us",
          href: e ? `/${e}/contact-us` : "/contact-us",
          className: a.menuItem
        },
        {
          key: "account",
          node: g,
          show: !!r
        }
      ]
    },
    {
      header: c ? "Areas of law" : "Topics",
      items: N[0].map((o) => ({
        key: `area-1-${o.title}`,
        label: o.footerTitle ?? o.title,
        href: o.link === "topics" ? `/${e}/${p}` : `/${e}/${p}/${o.link ?? A(o.title)}`,
        className: a.menuItem
      }))
    },
    {
      header: "",
      items: N[1].map((o) => ({
        key: `area-2-${o.title}`,
        label: o.footerTitle ?? o.title,
        href: o.link === "topics" ? `/${e}/${p}` : `/${e}/${p}/${o.link ?? A(o.title)}`,
        className: a.menuItem
      }))
    }
  ], [
    e,
    r,
    f,
    N,
    g,
    w,
    p,
    k
  ]);
  return /* @__PURE__ */ t($, { children: i.map((o, u) => /* @__PURE__ */ s("div", { className: a.column, children: [
    /* @__PURE__ */ t("div", { className: a.headerLabel, children: o.header ?? "" }),
    o.items.filter((l) => l.show !== !1).map(
      (l, b) => l.node ? /* @__PURE__ */ t(E.Fragment, { children: l.node }, `${l.key}-${b}`) : /* @__PURE__ */ t(
        "a",
        {
          href: l.href,
          className: l.className ?? a.menuItem,
          onClick: l.onClick,
          children: l.icon ? /* @__PURE__ */ s($, { children: [
            /* @__PURE__ */ t("span", { className: a.menuItemText, children: l.label }),
            l.icon
          ] }) : /* @__PURE__ */ t($, { children: l.label })
        },
        l.key
      )
    )
  ] }, u)) });
}, z = (m) => {
  const { language: e, accountComponent: g, getTranslation: r, newChatUrl: h } = m;
  return /* @__PURE__ */ s($, { children: [
    /* @__PURE__ */ s("div", { className: a.column, children: [
      /* @__PURE__ */ s(
        "a",
        {
          href: v({
            origin: h,
            language: e,
            ref: S.footerAsk
          }),
          className: `${a.menuItem} ${a.askQuestion}`,
          onClick: () => R("footer"),
          children: [
            r("pages.ask-a-question"),
            /* @__PURE__ */ t(F, { className: a.menuIcon })
          ]
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/about/company` : "/about/company",
          className: `${a.menuItem}`,
          children: r("pages.about")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/for-lawyers/legal-network` : "/for-lawyers/legal-network",
          className: `${a.menuItem}`,
          children: r("register.for-lawyers")
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: a.column, children: [
      e.includes("en") ? /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/insights` : "/insights",
          className: `${a.menuItem}`,
          children: r("pages.insights")
        }
      ) : null,
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/faqs` : "/faqs",
          className: `${a.menuItem}`,
          children: r("pages.faqs")
        }
      ),
      e.includes("en") ? null : /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/about/ai-technology` : "/about/ai-technology",
          className: `${a.menuItem}`,
          children: r("pages.ai-technology")
        }
      ),
      g
    ] }),
    /* @__PURE__ */ s("div", { className: a.column, children: [
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/contact-us` : "/contact-us",
          className: `${a.menuItem}`,
          children: r("pages.contact-us")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/terms` : "/terms",
          className: `${a.menuItem}`,
          children: r("pages.terms")
        }
      ),
      /* @__PURE__ */ t(
        "a",
        {
          href: e ? `/${e}/privacy` : "/privacy",
          className: `${a.menuItem}`,
          children: r("pages.privacy-policy")
        }
      )
    ] })
  ] });
};
export {
  fe as FooterComponent,
  G as SOCIAL_MEDIA_LINKS
};
